export const CUSTOMER_ANALYTICS_DATA_LAYER = "mangoCustomerAnalyticsLayer";

type CustomerAnalyticsCommand = IArguments | unknown[];

declare global {
	interface Window {
		mangoCustomerAnalyticsLayer?: CustomerAnalyticsCommand[];
	}
}

export function sendCustomerAnalyticsCommand(..._args: unknown[]): void {
	window.mangoCustomerAnalyticsLayer ??= [];
	// Google Tag expects the same arguments object produced by the canonical gtag snippet.
	// eslint-disable-next-line prefer-rest-params
	window.mangoCustomerAnalyticsLayer.push(arguments);
}
